import { browserCookies } from '@gousto-internal/storage-consent-web-package'
import type { Store } from 'redux'

import type { GoustoHeadersValueProvider } from '@library/http/src/requests/goustoHeadersValueProvider'

export function getGoustoHeadersValueProvider(store: Store): GoustoHeadersValueProvider {
  const valueProvider: GoustoHeadersValueProvider = () => {
    const [, cookieValue] = browserCookies.getJSON<{ exp_user_id: string }>('v1_exp_user_id')
    const experimentationUserId = cookieValue?.exp_user_id || null

    const [, sessionId] = browserCookies.getString('gousto_session_id')

    const { auth } = store.getState()

    const accessToken: string = auth.get('accessToken') || null
    const authUserId: string = auth.get('id') || null

    return {
      authToken: accessToken,
      authUserId,
      experimentationUserId,
      deviceId: sessionId ?? '00000000-0000-0000-0000-000000000000',
    }
  }

  return valueProvider
}
